import api from './axios';

// ponytail: simplified API client calls to single lines
export const getAllAdmissions = (params = {}) => api.get('/admissions', { params }).then((r) => r.data);
export const getAdmissionStats = () => api.get('/admissions/stats').then((r) => r.data);
export const getAdmissionById = (id) => api.get(`/admissions/${id}`).then((r) => r.data);
export const submitAdmission = (data) => api.post('/admissions', data).then((r) => r.data);
export const updateAdmissionStatus = (id, status, notes) =>
  api.patch(`/admissions/${id}/status`, { status, notes }).then((r) => r.data);
export const deleteAdmission = (id) => api.delete(`/admissions/${id}`).then((r) => r.data);

const admissionService = {
  getAllAdmissions,
  getAdmissionStats,
  getAdmissionById,
  submitAdmission,
  updateAdmissionStatus,
  deleteAdmission,
};

export default admissionService;
